import { Injectable, Injector } from '@angular/core';

import { Observable } from 'rxjs';

import { distinctUntilChanged, filter, tap } from "rxjs/operators";
import { MessageParameterChart } from '../models/message-parameter-chart.model';
import { MessageWebFeeder } from '../models/message-webfeeder';
import { BaseWebfeederScktConsumerService } from './base-webfeeder-sckt-consumer.service';
import { WebfeederModuleEnum, WebfeederServiceEnum } from '../enums/webfeeder';

@Injectable({
  providedIn: 'root'
})
export class CandleChartWebfeederSktService extends BaseWebfeederScktConsumerService {
   delay = '500';
  // override messageType = WebfeederMessageTypeEnum.DAILY_ORDER;


  constructor(
    public injector: Injector
  ) {
    super(
      WebfeederModuleEnum.CHART,
      WebfeederServiceEnum.CANDLE_CHART,
      injector
    )
  }

  getSubjectOfSubscription(subscriptionKey: string): Observable<any> | undefined {
    return this.webFeederSubscriptionSvc.getSubscription(subscriptionKey)?.subject?.pipe(
      filter(message => { return message && message.response_type == "gch" }),
      // map(message => {
      //   let messageObject = new Quote(message);
      //   let subscription = this.webFeederSubscriptionSvc.getSubscription(subscriptionKey)
      //   if (!!!subscription || !!!message) return;
      //   if (subscription && !!!subscription?.currentMessage) {
      //     subscription.currentMessage = messageObject
      //   }
      //   subscription.oldMessage = subscription.currentMessage as Quote;
      //   subscription.currentMessage = { ...subscription.oldMessage, ...messageObject } as Quote;
      //   return Object.assign(new Quote(), subscription.currentMessage);
      // }),
      distinctUntilChanged(),
    )
  }

  getMessageParameter(params?: any, format?: string[]) {
    let { quote, period, tick_size, quantity, realTime, dispatch, initDate, fimDate, filter, id } = params;
    let messageParameter = new MessageParameterChart();
    messageParameter = {
      ...messageParameter,
      dispatch,
      initDate,
      period,
      quantity,
      quote,
      realTime,
      tick_size,
      fimDate,
      filter,
      id
    }
    return messageParameter;
  }

  getMessageWebFeeder(messageParameter?: any, params?: any, format?: string[]) {
    const dataMsg: MessageWebFeeder = new MessageWebFeeder();
    dataMsg.token = this.getWebfeederScktToken()
    dataMsg.module = this.module;
    dataMsg.service = this.service;
    dataMsg.parameters = messageParameter;

    return dataMsg;
  }


  on(params?: any, format?: string[] | undefined): Promise<Observable<any> | undefined> {
    return super.on(params, format);
  }

  off(params?: any, format?: string[] | undefined): Promise<Observable<any> | undefined> {
    params.dispatch = false;
    return super.off(params);
  }

  protected getMessageIdentifier(message: any) {
    return btoa(`${this.module}|${this.service}|${message.quote}|${message.period}`);
  }

  protected getSubscriptionKeyToRegister(dataMsg: any) {
    return btoa(`${dataMsg.module}|${dataMsg.service}|${dataMsg.parameters.quote}|${dataMsg.parameters.period}`)
  }
}
